<template>
	<TripLayout>
		<slot />
	</TripLayout>
</template>

<script setup lang="ts">
	import { useSeoMeta } from '#imports'
	useSeoMeta({
		title: 'Passporter',
	})
</script>
